import * as React from "react";

import { LoginAppProvider } from "../../../Common";

export const ReactJoinLoginAppProvider: React.FunctionComponent = (props) => {
  return (
    <LoginAppProvider
      shouldLoginUsingTheSpecialAsynchronousApiInsteadOfFormPost={false}
      shouldContinueLoadingAfterLoginSuccess={true}
    >
      {props.children || []}
    </LoginAppProvider>
  );
};
